import script from "./MoneyInput.vue?vue&type=script&lang=ts"
export * from "./MoneyInput.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__